import { cva } from '@vizit/theme';

// Bare control styling shared by Input and TextArea; the field chrome comes from the wrapper.
export const inputClasses = cva({
  base: [
    'flex-1 font-regular',
    'bg-transparent',
    'border-none',
    'placeholder:text-placeholder',
    'focus:outline-none',
    'outline outline-0',
    'disabled:cursor-not-allowed disabled:bg-transparent',
  ],
});
